import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IPlayerChapter } from './chapters/IPlayerChapter';
import { IScrubAdapter } from './scrubAdapter/IScrubAdapter';

import { VideogularComponent } from '../Videogular.Component';

import styles from './VbScrubBarWithChapters.module.less';

@Component({
	selector: 'vb-scrub-bar-with-chapters',
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `
		<vb-scrub-bar-chapter
			*ngFor="let chapter of chapters; let i = index; last as isLast"
			[adapter]="adapter"
			[chapter]="chapter"
			[nextChapter]="chapters[i + 1]"
			[isLast]="isLast">
		</vb-scrub-bar-chapter>
	`,
	host: {
		'[class]': 'styles.chaptersContainer'
	}
})
export class VbScrubBarWithChaptersComponent {
	@Input() public chapters: IPlayerChapter[];
	@Input() public adapter: IScrubAdapter;

	public readonly styles = styles;

	constructor(
		public vgApi: VideogularComponent
	) {}

}
